@switch(type()) {
    @case (Type.DROPDOWN) {
        <div style="display: block; width: 100%">
            @if(multiValue()) {
            <sd-6-17-1-select [label]="showLabel() ? filter().name : undefined" lang="de" max-options-visible="2" usetags [size]="SIZE" multiple [value]="selectedValue()" (sd-change)="changeSelection($event)">
                @for (curOption of available(); track $index) {
                <sd-6-17-1-option [value]="curOption.key">{{curOption.value}}</sd-6-17-1-option>
                }
            </sd-6-17-1-select>
            } @else {
            <sd-6-17-1-select [label]="showLabel() ? filter().name : undefined" lang="de" [size]="SIZE" [value]="selectedValue()"  (sd-change)="changeSelection($event)">
                @for (curOption of available(); track $index) {
                <sd-6-17-1-option [value]="curOption.key">{{curOption.value}}</sd-6-17-1-option>
                }
            </sd-6-17-1-select>
            }
        </div> 
    }
    @case (Type.RADIO_BUTTON) {
        <sd-6-17-1-radio-group [label]="showLabel() ? filter().name : undefined" [size]="SIZE" [value]="selectedValue().length > 0 ? selectedValue()[0] : undefined" (sd-change)="changeSelection($event)">
            @for (curOption of available(); track $index) {
            <sd-6-17-1-radio-button [value]="curOption.key">
                <div>{{curOption.value}}</div>
            </sd-6-17-1-radio-button>
            }
        </sd-6-17-1-radio-group>
    }
    @case (Type.DATE_PICKER) {
        <sd-6-17-1-datepicker [size]="SIZE" #datePicker lang="de" locale="de-DE" [attr.range]="range() ? '' : null" [value]="selectedValue().length > 0 ? selectedValue()[0] : undefined" (sd-change)="changeDate($event)"></sd-6-17-1-datepicker>
    }
    @default { 
        -
    }
}